import { render, staticRenderFns } from "./AddressDisplay.vue?vue&type=template&id=6590ca52"
import script from "./AddressDisplay.vue?vue&type=script&lang=ts"
export * from "./AddressDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports